/* mm-scan-panel.js: behaviour for snippets/mm-scan-panel.liquid (cards),
   sections/pages/mm-dataset-download.liquid (scan page viewer) and
   snippets/mm-scan-form.liquid. Loaded with defer by every section that
   renders them; the guard keeps it to one copy per page.

   - Orbit video: loads and plays only while on screen, and in a carousel
     only on the active slide. Speed from data-mm-scan-rate. Skipped for
     reduced motion and Save-Data. Pause button for anything that loops.
   - Scan carousel (sections/mm-scan-panels.liquid): tabs, arrows, swipe.
   - Scan page viewer: a /p/ scene loads by itself on desktop with a fine
     pointer, and on a tap everywhere else. A /sample/ scene loads on the tap
     only and keeps the poster up until MapShare says it is ready. Full screen
     uses the viewer box; Open in MapShare is a plain link.
   - Download form: adds use-{choice} and company:{name} to the customer tags
     (Shopify's customer form drops contact[note]; the note is still sent in
     case that changes). After it posts back (?scan_posted=1) the form says it
     sent. */
(function () {
  if (window.mmScanPanel) return;
  window.mmScanPanel = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var autoLoad = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  var videos = [];

  // In a carousel only the active slide plays; the others never load.
  function syncVideo(video) {
    if (video.dataset.userPaused === '1' || video.dataset.retired === '1') return;
    var slide = video.closest('[data-mm-slide]');
    var active = !slide || slide.classList.contains('is-active');
    if (video.mmInView && active) {
      if (!video.getAttribute('src')) video.setAttribute('src', video.getAttribute('data-src'));
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    } else if (!video.paused) {
      video.pause();
    }
  }

  function initVideos() {
    if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;
    videos = Array.prototype.slice.call(document.querySelectorAll('video[data-mm-scan-video]'));
    if (!videos.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.mmInView = entry.isIntersecting;
          syncVideo(entry.target);
        });
      },
      { rootMargin: '200px 0px', threshold: 0.25 }
    );
    videos.forEach(function (video) {
      video.muted = true;
      // Speed from the section (data-mm-scan-rate). Loading a src resets
      // playbackRate to defaultPlaybackRate, so set both.
      var holder = video.closest('[data-mm-scan-rate]');
      var rate = holder ? parseFloat(holder.getAttribute('data-mm-scan-rate')) : NaN;
      if (rate > 0) {
        video.defaultPlaybackRate = rate;
        video.playbackRate = rate;
        video.addEventListener('loadedmetadata', function () {
          video.playbackRate = rate;
        });
      }
      var toggle = video.parentElement && video.parentElement.querySelector('[data-mm-scan-toggle]');
      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
        if (toggle) {
          toggle.hidden = false;
          toggle.textContent = 'Pause';
          toggle.setAttribute('aria-pressed', 'false');
        }
      });
      if (toggle) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (video.paused) {
            video.dataset.userPaused = '';
            video.play();
          } else {
            video.dataset.userPaused = '1';
            video.pause();
            toggle.textContent = 'Play';
            toggle.setAttribute('aria-pressed', 'true');
          }
        });
      }
      io.observe(video);
    });
  }

  // One scan at a time: tabs, arrows, and a scroll-snap track that also
  // swipes. The active slide follows the scroll position.
  function initCarousels() {
    document.querySelectorAll('[data-mm-scan-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-mm-slide-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mm-slide]'));
      if (!track || slides.length < 2) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mm-slide-tab]'));
      var prev = root.querySelector('[data-mm-slide-step="-1"]');
      var next = root.querySelector('[data-mm-slide-step="1"]');
      var current = 0;

      function setActive(index) {
        if (index === current) return;
        current = index;
        slides.forEach(function (slide, i) {
          var on = i === index;
          slide.classList.toggle('is-active', on);
          if (on) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');
        });
        tabs.forEach(function (tab, i) {
          var on = i === index;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
        });
        // Narrow screens scroll the tab strip; keep the active tab in it.
        var tab = tabs[index];
        if (tab && tab.parentElement.scrollWidth > tab.parentElement.clientWidth) {
          tab.parentElement.scrollTo({ left: tab.offsetLeft - 16, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        videos.forEach(syncVideo);
      }

      function goTo(index, focusTab) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(index);
        if (focusTab && tabs[index]) tabs[index].focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          goTo(i);
        });
        tab.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') goTo(current + 1, true);
          else if (event.key === 'ArrowLeft') goTo(current - 1, true);
          else return;
          event.preventDefault();
        });
      });
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });

      var settle = 0;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          setActive(Math.max(0, Math.min(slides.length - 1, index)));
        }, 80);
      }, { passive: true });
    });
  }

  // MapShare /sample/ links (public, framed) have no poster of their own, so
  // they start loading the scene the moment the iframe exists. Load them on
  // the visitor's click only, keep our poster up until MapShare posts
  // mapshare:ready, and fall back to the poster on mapshare:error.
  var MAPSHARE_ORIGIN = 'https://www.mapshare.app';
  var READY_TIMEOUT = 25000;

  function isSample(src) {
    return /^https:\/\/www\.mapshare\.app\/sample\//.test(src || '');
  }

  function revealViewer(box) {
    if (!box.classList.contains('is-loading')) return;
    box.classList.remove('is-loading');
    box.classList.add('is-live');
    clearTimeout(box.mmReadyTimer);
  }

  function failViewer(box) {
    if (!box.classList.contains('is-loading')) return;
    box.classList.remove('is-loading');
    clearTimeout(box.mmReadyTimer);
    var frame = box.querySelector('.mm-ds__frame');
    if (frame) frame.remove();
    var note = box.querySelector('.mm-ds__start-note');
    if (note) {
      note.textContent = 'The 3D scan could not load here. ';
      var open = document.createElement('a');
      open.href = box.getAttribute('data-src');
      open.target = '_blank';
      open.rel = 'noopener';
      open.textContent = 'Open it in MapShare';
      open.setAttribute('data-mm-scene-open', '');
      open.setAttribute('data-mm-cta-placement', 'dataset_viewer_fallback');
      open.setAttribute('data-mm-scene-handle', box.getAttribute('data-handle') || '');
      note.appendChild(open);
    }
    var load = box.querySelector('[data-mm-viewer-load]');
    if (load) load.hidden = true;
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== MAPSHARE_ORIGIN || !event.data || typeof event.data.type !== 'string') return;
    document.querySelectorAll('[data-mm-scan-viewer].is-loading').forEach(function (box) {
      var frame = box.querySelector('.mm-ds__frame');
      if (!frame || frame.contentWindow !== event.source) return;
      if (event.data.type === 'mapshare:ready') revealViewer(box);
      else if (event.data.type === 'mapshare:error') failViewer(box);
    });
    // MapShare's own Open in MapShare button, inside the frame. Any state.
    if (event.data.type !== 'mapshare:open' || typeof window.mmTrack !== 'function') return;
    document.querySelectorAll('[data-mm-scan-viewer]').forEach(function (box) {
      var frame = box.querySelector('.mm-ds__frame');
      if (!frame || frame.contentWindow !== event.source) return;
      window.mmTrack('mapshare_open', {
        cta_placement: 'dataset_viewer_frame',
        context_title: box.getAttribute('data-handle') || '',
        context_type: 'scene',
        link_url: 'https://www.mapshare.app/sample/' + (event.data.slug || '')
      });
    });
  });

  function loadViewer(box) {
    if (!box || box.classList.contains('is-live') || box.classList.contains('is-loading')) return;
    var src = box.getAttribute('data-src');
    if (!src) return;
    var frame = document.createElement('iframe');
    frame.className = 'mm-ds__frame';
    frame.src = src;
    frame.title = (box.getAttribute('data-title') || 'Scan') + ' in MapShare';
    frame.allow = 'fullscreen; xr-spatial-tracking; gyroscope; accelerometer';
    frame.setAttribute('allowfullscreen', '');
    box.appendChild(frame);
    if (isSample(src)) {
      box.classList.add('is-loading');
      var load = box.querySelector('[data-mm-viewer-load]');
      if (load) load.textContent = 'Loading the scan';
      // A scan that never reports in still gets shown rather than stuck.
      box.mmReadyTimer = setTimeout(function () {
        revealViewer(box);
      }, READY_TIMEOUT);
    } else {
      box.classList.add('is-live');
    }

    var video = box.querySelector('video[data-mm-scan-video]');
    if (video) {
      video.dataset.retired = '1';
      video.pause();
      video.removeAttribute('src');
      video.load();
    }
    var toggle = box.querySelector('[data-mm-scan-toggle]');
    if (toggle) toggle.hidden = true;
    // The tools sit under the viewer box so they never cover MapShare's own.
    var tools = box.parentElement && box.parentElement.querySelector('[data-mm-viewer-tools]');
    if (tools) tools.hidden = false;

    if (typeof window.mmTrack === 'function') {
      window.mmTrack('scene_open', {
        cta_placement: 'dataset_viewer',
        context_title: box.getAttribute('data-handle') || '',
        context_type: 'scene',
        link_url: src
      });
    }
  }

  function initViewers() {
    var boxes = document.querySelectorAll('[data-mm-scan-viewer][data-src]');
    if (!boxes.length) return;
    boxes.forEach(function (box) {
      var load = box.querySelector('[data-mm-viewer-load]');
      if (load) {
        load.addEventListener('click', function () {
          loadViewer(box);
        });
      }
      var full = box.parentElement && box.parentElement.querySelector('[data-mm-viewer-full]');
      if (full) {
        if (!box.requestFullscreen) {
          full.hidden = true;
        } else {
          full.addEventListener('click', function () {
            if (document.fullscreenElement) document.exitFullscreen();
            else box.requestFullscreen().catch(function () {});
          });
        }
      }
    });
    if (autoLoad.matches) {
      var start = function () {
        boxes.forEach(function (box) {
          if (!isSample(box.getAttribute('data-src'))) loadViewer(box);
        });
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    }
  }

  function initForms() {
    document.querySelectorAll('form[data-mm-scan-form]').forEach(function (form) {
      var tags = form.querySelector('[data-mm-scan-tags]');
      var base = tags ? tags.value : '';
      form.addEventListener('submit', function () {
        var note = form.querySelector('[data-mm-scan-note]');
        var use = form.querySelector('[data-mm-scan-use]');
        var company = form.querySelector('[data-mm-scan-company]');
        var useValue = use && use.value ? use.value : '';
        // The customer form drops contact[note], so company rides as a tag
        // (same shape as the existing source: tags). Commas would split it.
        var companyValue = company ? company.value.replace(/[,\s]+/g, ' ').trim().slice(0, 60) : '';
        if (tags) {
          tags.value =
            base +
            (useValue ? ',use-' + useValue : '') +
            (companyValue ? ',company:' + companyValue : '');
        }
        if (note) {
          var lines = ['Sample dataset: ' + (form.getAttribute('data-mm-scan-dataset') || '')];
          if (company && company.value.trim()) lines.push('Company: ' + company.value.trim());
          if (use && use.selectedIndex > 0) lines.push('Use: ' + use.options[use.selectedIndex].text);
          note.value = lines.join('\n');
        }
      });

      var posted = /[?&](scan_posted=1|customer_posted=true)/.test(window.location.search || '');
      if (posted) {
        var sent = form.querySelector('[data-mm-scan-sent]');
        var fields = form.querySelector('[data-mm-scan-fields]');
        if (sent) sent.hidden = false;
        if (fields) fields.hidden = true;
      }
    });
  }

  function init() {
    initVideos();
    initCarousels();
    initViewers();
    initForms();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
